import { useKeycloak } from "@react-keycloak/web";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import TextOrMdash from './TextOrMdash';
import DisplayFoto from './DisplayFoto';
import DeEscapeTxt from "./DeEscapeTxt";


function PrevVybaveni(props: any) {
    const { keycloak, initialized } = useKeycloak();
    const navigate = useNavigate();
    const viditelnost = useSelector((state: any) => state.miscDicts.viditelnost);
    //console.log("PrevVybaveni.tsx - viditelnost from Redux")
    //console.log(viditelnost)
    //
    return (
        <tr className='itemRow' key={props.vybaveni.id} onClick={() => navigate('/vybaveni/vybaveni/' + props.vybaveni.id)}>
            <td><TextOrMdash text={DeEscapeTxt(props.vybaveni.kod)}/></td>
            <td><TextOrMdash text={DeEscapeTxt(props.vybaveni.nazev)}/></td>
            <td><div>{props.vybaveni.vybaveniPouziti[0].rodina_kod}</div></td>{/*straight vybaveniPouziti[0]->{"rodina_kod":"MOD"}*/}
            {(typeof (props.vybaveni.foto) !== 'undefined' && props.vybaveni.foto != null)
                        ? <td width={"300px"}><div>{props.vybaveni.foto.map((foto: any)=> <DisplayFoto key={foto.fotoId} foto={foto}/>)}</div></td>
                        : <td>&mdash;</td>}
            <td><TextOrMdash text={DeEscapeTxt(props.vybaveni.modifikace)}/></td>
            <td><TextOrMdash text={DeEscapeTxt(props.vybaveni.popis)}/></td>
            <td><TextOrMdash text={DeEscapeTxt(props.vybaveni.design)}/></td>
            <td><TextOrMdash text={props.vybaveni.datumeditace}/></td>                  
            {keycloak.authenticated && (
            <td>{(typeof (viditelnost) !== 'undefined' && viditelnost != null && viditelnost.length != 0)
                    ? <TextOrMdash text={viditelnost.find((vid: any)=>vid.key===props.vybaveni.viditelnost).value} />
                    : <div>&mdash;</div>}</td>
            )} 
        </tr>)
}
export default PrevVybaveni